import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'assets/css/font.css'
import 'assets/css/main.css'
import * as echarts from 'echarts'
// main.js

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
// 高德地图start
import VueAMap from 'vue-amap' // 引入vue-amap
// 使用vue-amap
Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   // 高德的key
//   key: 'faefef6442543d73a6bb0cd1c12ecc65',
//   // 插件集合
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
//   v: '1.4.4'
// })

// 高德地图end
Vue.use(dataV)

Vue.use(ElementUI)
Vue.prototype.$EventBus = new Vue()

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
